import { BlocksRenderer } from "@strapi/blocks-react-renderer";

const TextBlock = ({ text }) => {
  return (
    <div>
      <BlocksRenderer
        content={Array.isArray(text) ? text : []}
        blocks={{
          image: ({ image }) => (
            <img
              src={image.url}
              alt={image.alternativeText}
              className="blocks-renderer-img"
            />
          ),
          list: ({ children, format }) =>
            format === "unordered" ? (
              <ul className="blocks-renderer-ul">{children}</ul>
            ) : (
              <ol className="blocks-renderer-ol">{children}</ol>
            ),
        }}
      ></BlocksRenderer>
    </div>
  );
};

export default TextBlock;
